document.addEventListener("DOMContentLoaded", function () {
  const galleries = document.querySelectorAll(".image-gallery-banner");
  if (!galleries.length) return;

  galleries.forEach((gallery) => {
    const baseCycleSpeed = parseInt(gallery.dataset.cycleSpeed, 10) || 5000;
    const items = Array.from(gallery.querySelectorAll(".image-gallery__item"));
    if (!items.length) return;

    const dataScript = gallery.querySelector(".image-gallery-data");
    if (!dataScript) return;

    let allImages = [];
    try {
      allImages = JSON.parse(dataScript.textContent);
    } catch (e) {
      console.error("Failed to parse image gallery data", e);
      return;
    }

    if (!allImages.length) return;

    let currentImages = items.map((item) => {
      const img = item.querySelector(".image-gallery__image");
      return img ? img.src : null;
    });

    const intervals = [];

    function shuffleArray(array) {
      const shuffled = [...array];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    }

    function getNextImage(excludeSrcs = []) {
      const available = allImages.filter(
        (img) => !excludeSrcs.includes(img.src)
      );

      if (!available.length) {
        const shuffled = shuffleArray([...allImages]);
        return shuffled[0];
      }

      return available[Math.floor(Math.random() * available.length)];
    }

    function updateImage(item, newImage, slotIndex) {
      const img = item.querySelector(".image-gallery__image");
      if (!img) return;

      img.classList.add("fade-out");
      img.classList.remove("fade-in");

      setTimeout(() => {
        img.src = newImage.src;
        img.alt = newImage.alt;
        currentImages[slotIndex] = newImage.src;
        img.classList.remove("fade-out");
        img.classList.add("fade-in");
      }, 2000);
    }

    function cycleSingleImage(item, slotIndex) {
      const displayedImages = currentImages.filter(Boolean);
      const nextImage = getNextImage(displayedImages);
      updateImage(item, nextImage, slotIndex);
    }

    function assignInitialImages() {
      const shuffled = shuffleArray([...allImages]);
      items.forEach((item, index) => {
        const img = item.querySelector(".image-gallery__image");
        if (!img) return;
        const imageData = shuffled[index % shuffled.length];
        img.src = imageData.src;
        img.alt = imageData.alt;
        currentImages[index] = imageData.src;
      });
    }

    assignInitialImages();

    items.forEach((item, index) => {
      const img = item.querySelector(".image-gallery__image");
      if (!img) return;

      const randomOffset = Math.random() * baseCycleSpeed;
      const speedVariation = 0.9 + Math.random() * 0.2;
      const individualSpeed = baseCycleSpeed * speedVariation;

      setTimeout(() => {
        const interval = setInterval(() => {
          cycleSingleImage(item, index);
        }, individualSpeed);
        intervals.push(interval);
      }, randomOffset);
    });

    const section = gallery.closest(".custom-text-with-images-banner");
    if (section) {
      let targetX = 0;
      let targetY = 0;
      let currentX = 0;
      let currentY = 0;
      const maxOffset = 16;
      const ease = 0.06;

      const depths = items.map(() => 0.4 + Math.random() * 0.6);

      function onMove(event) {
        const rect = section.getBoundingClientRect();
        const relX = (event.clientX - rect.left) / rect.width - 0.5;
        const relY = (event.clientY - rect.top) / rect.height - 0.5;
        targetX = relX * maxOffset;
        targetY = relY * maxOffset;
      }

      function onLeave() {
        targetX = 0;
        targetY = 0;
      }

      function tick() {
        currentX += (targetX - currentX) * ease;
        currentY += (targetY - currentY) * ease;

        items.forEach((item, index) => {
          const depth = depths[index];
          item.style.transform = `translate3d(${currentX * depth}px, ${currentY * depth}px, 0)`;
        });

        requestAnimationFrame(tick);
      }

      section.addEventListener("mousemove", onMove);
      section.addEventListener("mouseleave", onLeave);
      requestAnimationFrame(tick);
    }

    window.addEventListener("beforeunload", () => {
      intervals.forEach((interval) => clearInterval(interval));
    });
  });
});
